const Icon = ({ type }) => {
  return (
    <>
      {type === "Arrow" ? (
        <svg viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.143 9.5L10.143 5.5M10.143 5.5L6.143 1.5M10.143 5.5H1"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : type === "Logo" ? (
        <svg viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M29.0028 27.1005C25.6384 23.7365 23.7823 19.256 23.7823 14.5C23.7823 9.744 25.6384 5.25625 29.01 1.89225L27.1103 0L16.4083 10.701L18.308 12.6005L21.8318 9.077C21.3533 10.8243 21.114 12.644 21.114 14.5C21.114 16.356 21.3605 18.1758 21.8318 19.923L1.89968 0L0 1.8995C3.36432 5.2635 5.2205 9.73675 5.2205 14.5C5.2205 19.2633 3.36432 23.7365 0 27.1005L1.89968 29L12.6089 18.2917L10.7093 16.3923L7.18543 19.9158C7.66398 18.1685 7.90325 16.3488 7.90325 14.4928C7.90325 12.6368 7.65673 10.817 7.18543 9.06975L27.1103 28.9928L29.01 27.0933L29.0028 27.1005Z"
            fill="white"
          />
        </svg>
      ) : type === "Chevron" ? (
        <svg viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21 24.8L14.6 18.4L21 12"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="square"
          />
        </svg>
      ) : type === "BlackChevron" ? (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 15L13.5 10.5L9 6" stroke="black" strokeLinecap="square" />
        </svg>
      ) : (
        <></>
      )}
    </>
  );
};

export default Icon;
